import React from 'react';
import { Box, Alert } from '@mui/material';
import { useAuth } from '../../context/AuthContext';

const DisciplineAccessControl = ({ requiredDiscipline, children }) => {
  const { hasDiscipline } = useAuth();

  if (!hasDiscipline(requiredDiscipline)) {
    return (
      <Box sx={{ p: 3 }}>
        <Alert severity="error">
          Access Denied: You do not have the required '{requiredDiscipline}' discipline to view this page.
        </Alert>
      </Box>
    );
  }

  return children;
};

export default DisciplineAccessControl;